(function(){
  document.addEventListener('DOMContentLoaded', function() {

    var playButtonMulti = document.querySelectorAll('.multicolumn .deferred-media__poster-button');
    if ( playButtonMulti ) {
      setTimeout(function() {
        playButtonMulti.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
      }, 300);
    }

    window.sliderProductCard = function () {
      const sliderProductCard = new Swiper('cart-drawer-recommendations .slider--card:not(.swiper-initialized)', {
        slidesPerView: 1,
        //slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          type: 'bullets',
          el: ".swiper-pagination",
          clickable: true,
        },
        grabCursor: false, // pointer
        //thumbs: {
          //swiper: sliderThumbs, // thumb slider name
        //},
        breakpoints: {
          0: {
            pagination: {
            type: 'progressbar',
            el: ".swiper-pagination",
            clickable: false,
          },
          },
          750: {
            pagination: {
              type: 'bullets',
              clickable: true,
            },
          },
        },
        on: {
          init: function () {
            if(this.slides.length < 2) {
              this.el.classList.add('disabled');
            }
          }
        },
      });
    }

    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(event) {
        this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
      }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);
    
    function toggleFooterMenu() {
      
      let headerMenus = document.querySelectorAll('footer.footer .footer-block__heading');
      headerMenus.forEach(elem => {
        elem.addEventListener('click', function(e) {
          e.preventDefault();
          elem.classList.toggle('active');
        });
      });
    }
    toggleFooterMenu();
    
    document.addEventListener('click', function(e) {
      if ( e.target.matches('.variant_add_to_cart') || e.target.closest('.variant_add_to_cart')) {
        e.preventDefault();
        let checkbox = e.target.closest('.variant_wrapper')?.querySelector('label');
        checkbox?.click();
        setTimeout(function() {
          let addToCart = document.querySelector('product-info .product-form__submit');
          addToCart?.click();
        }, 1000);
      }
    });

    /**
    * code for position sticky header
    */
    function handleHeaderPosition() {
      let header = document.querySelector('.shopify-section-group-header-group.section-header');
      let announcementBarSection = document.querySelector('.announcement-bar-section');
      if ( ! header || ! announcementBarSection ) { 
        header.style.top = 0;
      } else {
        header.style.top = announcementBarSection.offsetHeight + 'px';
      }
      
    }
    handleHeaderPosition();
    
    var playButton = document.querySelectorAll('.banner_section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
      }, 100);
    }

    var playButton = document.querySelectorAll('#product-grid .video-section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('#product-grid .video-section video');
          videoelem.forEach( elem => {
            // window.scrollBy(0,2);
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('#product-grid .video-section video');
          videoelem.forEach( elem => {
            // window.scrollBy(0,2);
            elem.play();
          });
        });
      }, 100);
    }
    
    
    
     
    /*
    * start code for hover menu open
    */
    const inlineMenu = document.querySelectorAll(".header__inline-menu");
    const detailsItems = document.querySelectorAll(".header__inline-menu header-menu > details");
      detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul");
        item.addEventListener("mouseover", () => {
          item.setAttribute("open", true);
          ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
          item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
          });
        });
      });
     /*
    * end start code for hover menu open
    */

    /*
    * do summary menu clickable
    */
    const summaryMenu = document.querySelectorAll(".header__inline-menu header-menu > details > summary");
    summaryMenu.forEach(elem => {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        if ( elem.dataset.link ) {
          window.location.href = elem.dataset.link;
        }
      });
    });

    
    console.log('jsfile');
    window.initJsSlideProduct = () => {

      function isVideoPlay(that) {
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active .deferred-media__poster')?.length > 0 ) {
          document.querySelector('.js-product-main-slider .swiper-slide-active .deferred-media__poster').click();
          
          setTimeout(() => {
            // console.log("Delayed for 1 second.");
             if ( document.querySelector('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
              let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
              try {
                video[0].play();
              } catch (error) {
                console.log(error);
              }
            }
          }, "1000");
        }
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
          let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
          
          try {
            video[0].play();
          } catch (error) {
            console.log(error);
          }
        }
      }

      

      let containerProduct = document.querySelectorAll('product-info');
      
      containerProduct.forEach(elem => {
        let thumbItem = elem.querySelector('.js-product-thumbnail-slider');
        let sliderThumbnail = new Swiper(thumbItem, {
          spaceBetween: 15,
          mousewheel: true,
          slidesPerView: 6,
          // freeMode: true,
          on:{
            slideChangeTransitionEnd:function(){
              isVideoPlay(this);
            }
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 4,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 6,
            },
            750: {
               direction: 'vertical', // Set direction to vertical
              autoHeight: true,
            }
          }
        });
    
        let mainItem = elem.querySelector('.js-product-main-slider');
        window.galleryMain = new Swiper(mainItem, {
           initialSlide: mainItem.dataset.type > 1 ? 1 : 0,
          thumbs: {
            swiper: sliderThumbnail
          },
          // autoHeight: true,
          on:{
            slideChangeTransitionEnd:function(){
              changeVariantByImage(this);
              isVideoPlay(this);
            }
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              // centeredSlides: true,
              // loop: true,
              // initialSlide: 1,
              // spaceBetween: 15,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            },
            // when window width is >= 640px
            767: {
              slidesPerView: 1,
              
            }
          }
        });
      });

      /**
       * Code for changing slides in product slide for each variant
       */
      let productCur = document.querySelector('[data-tb-variants-json]');
      if (productCur) {
        productCur = JSON.parse(productCur.getAttribute('data-tb-variants-json'));
      }
      
      function variantImage(val) {
        const selectedVariantId = parseInt(val, 10);
        const variant = productCur.filter(v => v.id === selectedVariantId);
        
        const slickElements = document.querySelector('product-info .main-slider [data-for-slick]');
        
        if ( slickElements && document.querySelector(`[data-for-slick="${variant[0]?.featured_media?.id}"]:not(.swiper-slide-duplicate)`)) {
          const activeMedia = document.querySelector(`[data-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
          // const activeMedia = document.querySelector(`[data-for-slick="${variant[0].featured_media.id}"]:not(.swiper-slide-duplicate)`).getAttribute('data-swiper-slide-index');
          
          const numbers = activeMedia.split("/");
          const firstNumber = parseInt(numbers[0]);
          // const firstNumber = parseInt(activeMedia);
          window.galleryMain.slideTo(firstNumber - 1);
        }
      }
      
      const initialColorVariant = document.querySelector('product-info .product-variant-id');
      initialColorVariant?.addEventListener('change', function(event) {
        // debugger;
        const currentVariant = this;
        
        if (currentVariant) {
          const selectedVariantId = currentVariant.value;
          variantImage(selectedVariantId);
        }
      });

      /*
    * change variant by click on image
    */
     function changeVariantByImage(that) {
       let productObj = document.querySelector('[data-tb-variants-json]');
       if (productObj) {
          productObj = JSON.parse(productObj.getAttribute('data-tb-variants-json'));
       }
       
       let id = that.el.querySelector('.swiper-slide-active')
       id = id.getAttribute('data-for-slick');
       
       let selectedVariantId = parseInt(id, 10);
       let variants = productObj.filter(v => v?.featured_media?.id === selectedVariantId );
       
       variants.forEach(elem => {
         if ( elem.available === true ) {
           for( let i = 0; i < elem.options.length; i++ ) {
            //  console.log('elem', elem.options[i]);
             let inputOption = document.querySelector(`input[value="${elem.options[i]}"] + label`);
             inputOption.click();
           } 
         }
       });
      }
    }
    window.initJsSlideProduct();

    

    
 }, false);
})();
